<template>
  <div class="wrp3">
    <div class="top-header top clear">
      <h1 class="clear">
        <span @click="linkTo('/account')">Venue Account</span>
        <span @click="linkTo('/master')" class="activate">Master Account</span>
      </h1>
      <div class="search">
        <input type="text" @input="watchkey" v-model="key" />
      </div>
    </div>
    <div class="btns clear">
      <button class="light" @click="add">New Master Account</button>
    </div>
    <div class="table-wrp master-account" style="min-width:890px">
      <el-table
          :data="tableData2"
          style="width: 100%">
        <el-table-column
          label="Username"
          prop="userName">
        </el-table-column>
        <el-table-column
          label="Owner’s Name"
          prop="venueOwner">
        </el-table-column>
        <el-table-column
          label="account & password">
          <template slot-scope="scope">
            <div style="text-align:left;margin-bottom:10px">{{scope.row.venueMobile}}</div>
            <div style="text-align:left" class="clear">
              {{scope.row.visible ? scope.row.password : scope.row.star}}
              <!--<div class="ico-invisible" :class="{'ico-visible': scope.row.visible}" @click="scope.row.visible = !scope.row.visible"></div>-->
            </div>
          </template>

        </el-table-column>
        <el-table-column
          label="Linked Venues">
          <template slot-scope="scope">
            <div class="label-array clear" v-if="scope.row.subVenueList && scope.row.subVenueList.length > 0">
              <div class="label" v-for="(item, index) in scope.row.subVenueList"
              :key="index">{{item ? item['venueName'] : ''}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Operation"
          width="245">
          <template slot-scope="scope">
            <div class="btns clear">
              <button class="light" @click="linkTo(`/editmaster/${scope.row.venueId}`)">Edit</button>
              <button class="dark" @click="showDelete = true, operateId = scope.row.venueId">Remove</button>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
        </template>
      </el-table>
      <div class="ros_footerPage">
        <el-pagination
            v-if="!loading"
            class="my_pageSel"
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :current-page.sync="page"
            :total="totalRecord">
        </el-pagination>
    </div>
    </div>

    <el-dialog
      title="Are you sure you want to remove this account ?"
      :visible.sync="showDelete"
      :modal-append-to-body="false"
      :show-close="false"
      class="delsmsDio_box"
      :close-on-click-modal="false"
      width="740px"
      center>
        <div class="foot_box">
          <el-button @click="cancelOperate" class="cardCanBtn">Cancel</el-button>
          <el-button class="cardConBtn" @click="confirmDelete">Delete</el-button>
        </div>
    </el-dialog>

  </div>
</template>

<script>
import api from '../../api/account'

export default {
  data () {
    return {
      tableData2: [],
      loading: true, // 是否正在加载
      totalRecord: 0,
      page: 1,
      pagesize: 10,
      timeout: null,
      key: '',
      //
      showDelete: false,
      operateId: null,
      deleting: false
    }
  },
  created () {
    sessionStorage.removeItem('page')
    sessionStorage.removeItem('key')
    // 下方表格
    if (this.$route.params.page)
      this.page = parseInt(this.$route.params.page)
    if (this.$route.params.key)
      this.key = this.$route.params.key
    this.getList()
  },
  methods: {
    cancelOperate () {
      if (this.deleting)
        return
      this.showDelete = false
    },
    confirmDelete () {
      if (this.deleting)
        return
      api.masterVenueDelete({
        params: this.operateId,
        callback: (res) => {
          this.showDelete = false
          if (res.data.code === 0) {
            this.getList()
          } else {}
        }
      })
    },
    linkTo (path) {
      this.$router.push(path)
    },
    // 新增venue
    add () {
      this.$router.push('/createmaster')
    },
    getList () {
      this.tableData2 = []
      this.loading = true
      // 加载表格
      const data = {
        pageNum: this.page,
        pageSize: this.pagesize
      }
      if (this.key.replace(/\s+/g,'') !== '')
        data.keyword = this.key
      this.tableData2 = []
      this.loading = true
      api.getMasterLst({
        params: data, 
        callback: this.lstCallback
      })
    },
    pageChange (page) {
      this.page = page
      this.getList()
    },
    lstCallback (res) {
      var that = this
      if(res.data.code == 0){
        // 等待接口
        if (this.page !== 1 && res.data.data.list.length === 0) {
          this.page -- 
          this.getList()
        } else {
          that.loading = false
          console.log(res.data)
          res.data.data.list.forEach(item => {
            item.createTime = that.$box.timestampToTime(item.createTime)
            item.venueMobile = that.$box.formatNumber(item.venueMobile)
            item.monthlyFee = Utils.formatSplit(item.monthlyFee)
            item.visible = true
            let lgt = item.password.length
            let star = ''
            for (let i = 0; i < lgt; i ++) {
              star = star + '*'
            }
            item.star = star
          })
          this.tableData2 = res.data.data.list
          this.totalRecord = res.data.data.total
        }
      } else{
        that.loading = false
        Utils.alert('', res.data.message, 'error')
      }
    },
    // 搜索关键词，
    keySearch (key) {
      this.page = 1
      this.key = key
      this.getList()
    },
    watchkey() {
      var that = this
      if (that.timeout) {
          clearTimeout(that.timeout)
      }
      that.timeout = setTimeout(() => {
          that.keySearch.call(that, that.key)
      }, 2000) 
    }
  },
  /*watch: {
      'key': {
          deep: true,
          handler: function (val) {
              var that = this
              if (that.timeout) {
                  clearTimeout(that.timeout)
              }
              that.timeout = setTimeout(() => {
                  that.keySearch.call(that, val)
              }, 2000) 
          }
      }
  }*/
}
</script>

<style lang="scss" scoped>
.ico-invisible{
    display: inline-block;
    margin-left: 5px;
    width: 20px;
    height: 14px;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    background-image: url('../../assets/e2.png');
    cursor: pointer;
}
.ico-visible{
    background-image: url('../../assets/e.png');
}

.ros_footerPage{
    display: flex;
    justify-content: center;
}
.wrp3{
  color: #fff;
  padding-bottom: 50px;
  .top{
    width: 100%;
    margin-bottom: 48px;
    h1{
      float: left;
      margin-right: 50px;
      span{
        float: left;
        margin-right: 40px;
        position: relative;
        cursor: pointer;
      }
      .activate::after{
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 41px;
        width: 100%;
        height: 2px;
        background: #EA3796;
      }
    }
    .search{
      float: right;
      width: 300px;
      border-bottom: 1px solid #fff;
      background-size: 24px 22px;
      background-position: left center;
      background-repeat: no-repeat;
      background-image: url('../../assets/s.png');
      margin-top: -3px;
      input{
        outline: none;
        border: none;
        line-height: 30px;
        font-size: 16px;
        font-family:'PingFangSC-Regular,PingFang SC';
        width: 100%;
        background-color: transparent;
        color: #fff;
        box-sizing: border-box;
        padding-left: 30px;
      }
    }
  }
  .btns{
    width: 100%;
    margin-bottom: 30px;
    button{
      outline: none;
      border: none;
      height: 60px;
      font-family: 'PingFangSC-Semibold';
      font-size: 26px;
      background-color: transparent;
    }
    .light{
      width: 280px;
      border: 1px solid #EA3796;
      margin-right: 30px;
      color: #EA3796;
      cursor: pointer;
    }
    .dark{
      border: 1px solid #FFFFFF;
      color: #FFFFFF;
      width: 200px;
      cursor: pointer;
    }
    .disable{
      border: 1px solid gray;
      color: gray;
      cursor: not-allowed;
    }
  }
  .table-wrp{
    .btns{
      margin-bottom: 0;
    }
    button{
      height: 40px;
      font-size: 18px;
    }
    .light{
      width: 100px;
      margin-right: 10px;
    }
    .dark{
      width: 100px;
    }
    .label-array{
      box-sizing: border-box;
      padding: 15px 10px 0 20px;
      .label{
        float: left;
        margin-right: 10px;
        box-sizing: border-box;
        padding: 5px 15px;
        cursor: pointer;
        font-size: 12px;
        font-family: SFProText-Regular, SFProText;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
        background-color: #2B3444;
        border-radius: 20px;
        margin-bottom: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/master.vue